import {
  ACTION_CREATE_CAMPAIGN__REQUEST,
  ACTION_CREATE_CAMPAIGN__SUCCESS,
  ACTION_CREATE_CAMPAIGN__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_CREATE_CAMPAIGN__REQUEST:
    case ACTION_CREATE_CAMPAIGN__SUCCESS:
      return null;

    case ACTION_CREATE_CAMPAIGN__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
